"use strict";
/** @jsx jsx */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const index_1 = __importDefault(require("./index"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SaveLoader = ({ title, description }) => (core_1.jsx("div", { className: styles_scss_1.default.saveLoader },
    core_1.jsx(index_1.default, null),
    core_1.jsx("h2", null, title),
    core_1.jsx("p", null, description)));
SaveLoader.defaultProps = {
    title: '',
    description: '',
};
exports.default = SaveLoader;
